import styled, { css, SimpleInterpolation } from 'styled-components';

import Media from '../../../assets/styles/media';
import THEME from '../../../assets/styles/config';

export const ClearBtn = styled.div`
  font-size: 14px;
  height: 20px;
  border-bottom: ${THEME.colors.tertiaryFontColor} 1px solid;
  cursor: pointer;

  :hover {
    font-weight: bold;
    border-bottom: ${THEME.colors.tertiaryFontColor} 2px solid;
  }

  ${Media.Below.desktopLarge`
    margin-left: 34px;
  `}
`;

export const CloseXBtn = styled.div<SearchTabProps>`
  display: none;

  ${Media.Below.desktopLarge`
    display: initial
    margin-left: auto;
    cursor: pointer;
  `}
`;

export const Divider = styled.div`
  height: 2px;
  width: 100%;
  background-color: ${THEME.colors.tertiaryFontColor};
  margin-top: 15px;

  ${Media.Below.mobileLarge`
    display: none;
  `}
`;

export const FilterFormCtn = styled.form`
  display: flex;
  flex-direction: column;
  position: relative;
  min-width: 300px;

  ${Media.Below.desktopLarge`
    min-width: 250px;
    height: 80%;
  `}
`;

export const FilterHead = styled.div`
  display: flex;
  justify-content: space-between;

  > span {
    font-size: 23px;
    font-weight: bold;

    ${Media.Below.tablet`
      font-size: 22px;
    `}
  }

  ${Media.Below.desktopLarge`
    justify-content: normal;
    align-items: center;
  `}
`;

export const FiltersCtn = styled.div`
  /* width */
  &::-webkit-scrollbar {
    width: 3px;
  }

  /* Track */
  &::-webkit-scrollbar-track {
    background: transparent;
  }

  /* Handle */
  &::-webkit-scrollbar-thumb {
    background: #c8cacb;
  }

  ${Media.Below.desktopLarge`
    max-height: 78vh;
    overflow: auto;
  `}
  ${Media.Below.mobileLarge`
    max-height: 85vh;
  `}
`;

interface SearchTabProps {
  show?: boolean;
}

export const SearchTabCtn = styled.div<SearchTabProps>`
  border-bottom: grey 1px solid;
  background-color: white;
  height: 100%;
  box-shadow: 0 2px 4px 0 rgba(0, 130, 189, 0.2);
  position: relative;
  max-width: 80px;
  padding: 55px 0;
  transition: all 0.5s ease-in-out;
  cursor: pointer;

  ${(props): SimpleInterpolation =>
    css &&
    props.show &&
    `
      max-width: 480px;
      padding: 55px 50px 55px 4vw;
      cursor: default;

      @media screen and (max-width: ${THEME.layout.desktopLarge.breakpoint}px) {
        max-width: unset;
        position: fixed;
        top: 0;
        z-index: 5;
        overflow: auto;
        padding: 30px;
      }

      @media screen and (max-width: ${THEME.layout.mobileLarge.breakpoint}px) {
        padding: 15px;
        z-index: 200;
      }
    `};

  ${(props): SimpleInterpolation =>
    css &&
    !props.show &&
    `
      @media screen and (max-width: ${THEME.layout.desktopLarge.breakpoint}px) {
        display: none;
      }
    `};

  > span {
    opacity: 1;
    transition: opacity 0.3s ease-in-out;

    ${(props): SimpleInterpolation =>
      css &&
      props.show &&
      `
      opacity: 0;
    `};
  }
`;

